import { formatPriceChangePercent } from "@/components/dashboard/commons"
import * as styles from "@/components/dashboard/mySupplyBorrow/styles"
import { Box, Stack } from "@mui/material"

import BigNumber from "bignumber.js"
import React from "react"

import { priceChangeState } from "@/atoms/priceChangeState"
import { useAtomValue } from "jotai"

export type SupplyPriceChangeDisplayProps = {
  symbol: string
}
export const SupplyPriceChangeDisplay = ({ symbol }: SupplyPriceChangeDisplayProps) => {
  const priceChange = useAtomValue(priceChangeState)
  // Get the price change for the selected symbol
  const priceChangeData = priceChange[symbol]
  const percentChange = BigNumber(priceChangeData?.percentChange ?? 0).div(100)

  const style = priceChangeData?.isPositive
    ? styles.greenBold
    : priceChangeData?.isPositive === false
      ? styles.redBold
      : styles.grayBold
  const textStyle = { ...styles.supplyPriceChangeCell, ...style }
  return (
    <Stack gap={0} direction='column' justifyContent='center'>
      <Box sx={textStyle}>{formatPriceChangePercent(percentChange, textStyle)}</Box>
    </Stack>
  )
}
